import type { FC } from 'react';
import React, { useState } from 'react';
import { Container, Stack } from '@mui/material';
import { Button, HeaderBreadcrumbs, Iconify } from '@pflegenavi/web-components';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useTranslation } from 'react-i18next';
import { ServicesOverviewTableTable } from '../components/services/ServicesOverviewTable';
import { AddNewServiceModal } from '../components/services/AddNewServiceModal';
import { ServiceProviderSettings } from '../components/services/ServiceProviderSettings';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ServicesOverviewPageProps {}

export const ServicesOverviewPage: FC<ServicesOverviewPageProps> = () => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <Container sx={{ maxWidth: 1400 }}>
      <HeaderBreadcrumbs
        heading={t('service-provider-page.services.title')}
        links={[
          {
            name: t('service-provider-page.services.title'),
            href: spAppMainPages.SERVICES,
          },
          {
            name: t('service-provider-page.services.overview'),
          },
        ]}
        action={
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => setModalOpen(true)}
          >
            {t('service-provider-page.services.add-new-service')}
          </Button>
        }
      />
      <Stack gap={3}>
        <ServiceProviderSettings />
        <ServicesOverviewTableTable />
      </Stack>
      <AddNewServiceModal
        key={modalOpen.toString()}
        open={modalOpen}
        setOpen={setModalOpen}
      />
    </Container>
  );
};
